export default __webpack_public_path__ + "static/media/arrow.2a5b69ea.svg";